module.exports = __webpack_public_path__ + "img/product-attr04.0c68f81d.png";